export const SOCIAL_ICON_SRC = {
  facebook: require("../../images/footer-facebook.svg"),
  instagram: require("../../images/footer-instagram.svg"),
  x: require("../../images/footer-x.svg"),
  youtube: require("../../images/footer-youtube.svg")
};

export function toTelHref(phoneNumber) {
  if (!phoneNumber) {
    return "#";
  }
  return `tel:${String(phoneNumber).replace(/\s/g, "")}`;
}

export function getCopyrightYear() {
  return new Date().getFullYear();
}
